export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '录单时间',
		align: 'center',
		dataIndex: 'createTime',
		scopedSlots: { customRender: 'createTime' },
	},
	{
		title: '代理类型',
		align: 'center',
		dataIndex: 'agentType',
		scopedSlots: { customRender: 'agentType' },
	},
	{
		title: '任务类型',
		align: 'center',
		dataIndex: 'taskType',
		scopedSlots: { customRender: 'taskType' },
	},
	{
		title: '订单号',
		align: 'center',
		dataIndex: 'orderNo',
	},
	{
		title: '报案号',
		align: 'center',
		dataIndex: 'caseNo',
	},
	{
		title: '法院案号',
		align: 'center',
		dataIndex: 'courtCaseNo',
	},
	{
		title: '原告',
		align: 'center',
		dataIndex: 'plaintiff',
	},
	{
		title: '诉讼地区',
		align: 'center',
		dataIndex: 'fullDesc',
	},
	{
		title: '任务状态',
		align: 'center',
		dataIndex: 'orderStatus',
		scopedSlots: { customRender: 'orderStatus' },
	},
	{
		title: '操作',
		align: 'center',
		key: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
